import {
  Input,
  OnInit,
  Output,
  ViewChild,
  Component,
  EventEmitter,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { AreYouSureComponent } from 'src/app/feature';
import { getMainFileOrNothing, Order, OrderActionType } from 'src/app/shared';
import { MatCheckbox } from '@angular/material/checkbox';
import { ShoppingCartHandlerService } from '../../../feature/payment/services';
import { FileEntity } from 'src/app/core';
import { Router } from '@angular/router';
const _ = require('lodash');

@Component({
  selector: 'shared-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  @Input('actionsOn') actionsOn: boolean = false;

  @Input('orderObject') orderObject!: Order;
  @Output('orderObjectChange') orderObjectChange = new EventEmitter<Order>();

  @Output('delete') deleteEvent: EventEmitter<any> = new EventEmitter();
  @Output('select') selectEvent: EventEmitter<Order> = new EventEmitter();
  @Output('disSelect') disSelectEvent: EventEmitter<Order> = new EventEmitter();

  @Output('copyIncreased') copyIncreased = new EventEmitter();
  @Output('copyDecreased') copyDecreased = new EventEmitter();

  @Output() change = new EventEmitter<OrderActionType>();
  @Output('edit') edit = new EventEmitter();

  printPagesNum: string = '';
  BWPagesCount: string = '';
  mainFile?: FileEntity;

  @ViewChild('selectCheckbox')
  public selectCheckBox!: MatCheckbox;
  public createdOrder!: Order;

  // --------------------------------------- Get & Set|

  public get bwBlocks() {
    return this.mainFile?.fileBlocks?.filter((block) => {
      return block.stock?.type?.endsWith('bw');
    });
  }

  public get colorFulBlocks() {
    return this.mainFile?.fileBlocks?.filter((block) => {
      return (
        block.stock?.type?.endsWith('c') && !block.stock.type.endsWith('hc')
      );
    });
  }

  public get halfColorBlocks() {
    return this.mainFile?.fileBlocks?.filter((block) => {
      return block?.stock?.type?.endsWith('hc');
    });
  }

  // Constructors ---------------------------------->

  constructor(
    private shoppingCartHandler: ShoppingCartHandlerService,
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.mainFile = getMainFileOrNothing(this.orderObject.files);
  }

  public getType() {
    return this.shoppingCartHandler.getType(this.orderObject);
  }

  public getPrintType() {
    return this.shoppingCartHandler.getDisplayStatus(this.orderObject);
  }

  public getPrintSize() {
    return (
      getMainFileOrNothing(this.orderObject?.files)?.fileBlocks?.at(0)?.stock
        ?.name || ''
    );
  }

  public getMainFile(files?: FileEntity[]) {
    if (!files) {
      return undefined;
    }
    return files.filter((file) => file.fieldname)?.at(0);
  }

  public getBwPagesCount() {
    return this.bwBlocks?.length || 0;
  }

  public getDisplayStatus() {
    return this.shoppingCartHandler.getDisplayStatus(this.orderObject);
  }

  public runAction(actionType: OrderActionType, forceDelete = false) {
    this.orderObject.selected = false;

    if (actionType === 'decreaseCopy' && (this.orderObject.copiesNumber === 1 || forceDelete)) {
      this.dialog
        .open(AreYouSureComponent, {
          height: '100px',
        })
        .afterClosed()
        .subscribe({
          next: (result: unknown) => {
            if (!!result) {
              this.shoppingCartHandler
                .handleAction({
                  id: this.orderObject.id,
                  type: actionType,
                })
                .subscribe((data: Order | boolean) => {
                  this.deleteEvent.emit();
                  this.change.emit(actionType);
                });
            }
          },
        });

      return;
    }

    this.shoppingCartHandler
      .handleAction({
        id: this.orderObject.id,
        type: actionType,
      })
      .subscribe((data: Order | boolean) => {
        this.orderObject = data as Order;
        this.orderObject.selected = false;
        this.orderObjectChange.emit(data as Order);
        this.change.emit(actionType);
      });
  }

  public editOrder() {
    this.router.navigate([this.orderObject.type, 'e', this.orderObject.id]);
  }

  // ------------------------------------------Private methods|

  ngOnDestroy() {}
}
